// This file is generated on build. To make changes, see scripts/version.js

/**
 * The current version of the library.
 */
export const version: string = '1.0.1';
